import { useGameStore } from '@/store/gameStore'
import { EventBus, GameEvents } from '@/game/utils/EventBus'
import { Play, Pause } from 'lucide-react'

export function TimeControls() {
  const { isPaused, gameSpeed, setPaused, setGameSpeed } = useGameStore()

  const handlePause = () => {
    setPaused(!isPaused)
    EventBus.emit(isPaused ? GameEvents.GAME_RESUMED : GameEvents.GAME_PAUSED)
  }

  const handleSpeed = (speed: number) => {
    setGameSpeed(speed)
    if (isPaused) {
      setPaused(false)
      EventBus.emit(GameEvents.GAME_RESUMED)
    }
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      {/* Pause/Play button */}
      <button
        onClick={handlePause}
        className={`hud-pause${isPaused ? ' paused animate-pulse-orange' : ''}`}
        title={isPaused ? 'Reanudar' : 'Pausar'}
      >
        {isPaused ? <Play size={18} /> : <Pause size={18} />}
      </button>

      {/* Speed buttons */}
      <div className="hud-speed">
        {[1, 2, 4].map(speed => (
          <button
            key={speed}
            onClick={() => handleSpeed(speed)}
            className={`hud-speed-btn${gameSpeed === speed && !isPaused ? ' active' : ''}`}
          >
            {speed}x
          </button>
        ))}
      </div>
    </div>
  )
}
